import React from 'react';

import Grid from '@material-ui/core/Grid';

import { fractionToPercent } from 'helpers/helpers';
import useGeneralStyles from 'apps/Pdf/styles/general';
import useStyles from './FeeLineStyle';

interface Props {
  heading?: string;
  subheading?: string;
  title: string;
  subtitle?: string;
  original?: number;
  percentage?: number;
  variant?: 'main' | 'main2' | 'sub';
  noBorder?: boolean;
  share: [number, number];
}

const FeeLine = (props: Props) => {
  const styles = useGeneralStyles();
  const classes = useStyles();

  return (
    <Grid
      container
      alignItems="center"
      className={`${styles.lines} ${styles.regularText} ${classes.root}
      ${props.variant === 'main' ? 'bgrLighter' : ''}
      ${props.variant === 'main2' ? 'main2' : ''}
      ${props.noBorder ? 'noBorder' : ''}
      ${props.variant === 'sub' ? 'sub' : ''}
      `}
    >
      {props.heading !== undefined || props.subheading !== undefined ? (
        <>
          <Grid item xs={4}>
            {props.heading}
            {props.heading && props.subheading && <br />}
            {props.subheading && <span className={styles.supplement}>{props.subheading}</span>}
          </Grid>
          <Grid item xs={3} className={styles.supplement}>
            {props.title}
          </Grid>
        </>
      ) : (
        <Grid item xs={7} className={`${props.variant === 'main2' ? styles.bold : ''}`}>
          {props.title}
          {props.subtitle && <span className={styles.supplement}> {props.subtitle}</span>}
        </Grid>
      )}

      <Grid item xs={2} className={styles.right} style={{ whiteSpace: 'nowrap' }}>
        {props.percentage !== undefined && fractionToPercent(props.percentage, 2)}
        {props.original !== undefined && props.original !== props.percentage && (
          <>
            {' '}
            <span style={{ textDecoration: 'line-through' }}>
              {fractionToPercent(props.original, 2)}
            </span>
          </>
        )}
      </Grid>
      <Grid item xs={1} className={`${styles.center} ${styles.halfXs}`}>
        =
      </Grid>
      <Grid item xs={1} className={styles.right}>
        {props.percentage !== undefined && fractionToPercent(props.share[0], 2)}
      </Grid>
      <Grid item xs={1} className={`${styles.center} ${styles.halfXs}`}>
        +
      </Grid>
      <Grid item xs={1} className={styles.right}>
        {props.percentage !== undefined && fractionToPercent(props.share[1], 2)}
      </Grid>
    </Grid>
  );
};

export default FeeLine;
